import { render, staticRenderFns } from "./product-modal.vue?vue&type=template&id=0299ffde&"
import script from "./product-modal.vue?vue&type=script&lang=js&"
export * from "./product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports